// services/axios8300.js

import axios from 'axios';

const axios8300 = axios.create({
  baseURL: 'https://valuepyramid-22559651326.us-east1.run.app',
  headers: {
    'Content-Type': 'application/json',
  },
});
// const axios8300 = axios.create({
//   baseURL: 'http://localhost:8300', // Adjust to the correct base URL
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });
export default axios8300;
